import TutorSigin from "./TutorSigin";
import TutorSigup from "./TurtorSignup";
import TutorForgetPas from "./TutorForgetPas";
import SignupPasswordStep from "./SignupPasswordStep";
import React from "react";
import {TUTORLOGIN, TUTORSIGNUP, TUTORPASSWORDFORGOT, STEP_TUTORPROFILESINGUP, STEP_PASSWORDSIGNUP} from './const';
import Spinner from 'react-bootstrap/Spinner'

class TutorAuth extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      page: TUTORLOGIN,
      signupStep: STEP_TUTORPROFILESINGUP,
      loading: false
    };

    this.goToLogin = this.goToLogin.bind(this);
    this.goToSignup = this.goToSignup.bind(this);
    this.goToForgetPassword = this.goToForgetPassword.bind(this);
    this.goToPasswordProfile = this.goToPasswordProfile.bind(this);
    this.goToTutorProfile = this.goToTutorProfile.bind(this);
  }

  // goToSchoolProfile() {
  //   this.setState({signupStep: STEP_SCHOOLPROFILESIGNUP})
  // }

  goToTutorProfile() {
    this.setState({signupStep: STEP_TUTORPROFILESINGUP, loading: true})
    setTimeout(() => {
      this.setState({
        loading: false
      })
    }, 300);
  }

  goToPasswordProfile() {
    this.setState({signupStep: STEP_PASSWORDSIGNUP, loading: true})
    setTimeout(() => {
      this.setState({
        loading: false
      })
    }, 300);
  }

  
  goToLogin() {
    this.setState({page: TUTORLOGIN, loading: true})
    setTimeout(() => {
      this.setState({
        loading: false
      })
    }, 300);
  }

  goToForgetPassword() {
    this.setState({page: TUTORPASSWORDFORGOT, loading: true})
    setTimeout(() => {
      this.setState({
        loading: false
      })
    }, 300);
  }

  goToSignup() {
    this.setState({page: TUTORSIGNUP, loading: true, signupStep: STEP_TUTORPROFILESINGUP})
    setTimeout(() => {
      this.setState({
        loading: false
      })
    }, 300);
  }

  renderSignupStep(){
    switch (this.state.signupStep) {
      case STEP_TUTORPROFILESINGUP:
         return <TutorSigup goToLogin={this.goToLogin}  next={this.goToPasswordProfile}/>
      // case STEP_SCHOOLPROFILESIGNUP:
      //   return <SignupSchoolDetailStep goToLogin={this.goToLogin} back={this.goToProfile} next={this.goToPasswordProfile}/>
      case STEP_PASSWORDSIGNUP:
        return <SignupPasswordStep goToLogin={this.goToLogin} back={this.goToTutorProfile}/>
      default:
        break;
    }
  }

  renderPage() {
    window.history.replaceState(null, "Student Signin", "/pro")
    if(this.state.loading){
      return <div className="w-100 d-flex align-items-center justify-content-center loader" ><Spinner animation="grow" variant="primary" /></div>
    }
    switch (this.state.page) {
      case TUTORLOGIN:
        return  <TutorSigin goToSignup={this.goToSignup} goToForgetPassword={this.goToForgetPassword}/> 
      case TUTORPASSWORDFORGOT:
        return  <TutorForgetPas goToLogin={this.goToLogin}/> 
      case TUTORSIGNUP:
        return  this.renderSignupStep()
      default:
        break;
    }
  }

  render() {
    return this.renderPage()
  }

}

export default TutorAuth;